'use client'
import { useParams, useRouter } from 'next/navigation';
import { useEffect } from 'react';
import { Footer } from "../../components/common/Footer2";
import ProjectDetail from "../../components/common/projects/ProjectDetail";
import { projectsData } from "../../lib/fackData/projectsData";
import { QuickLinkBox } from "../../components/common/QuickLinkBox";

export default function ProjectDetailPage() {
  const params = useParams();
  const router = useRouter();
  const slug = params?.slug as string;

  useEffect(() => {
    if (!slug) {
      router.push('/projects');
      return;
    }

    const project = projectsData.find(p => p.slug === slug);
    if (!project) {
      router.push('/projects');
    }
  }, [slug, router]);

  return (
    <>
      <ProjectDetail projectSlug={slug}></ProjectDetail>
      <QuickLinkBox></QuickLinkBox>
      <Footer></Footer>
    </>
  );
}

